export default __webpack_public_path__ + "static/media/expressions background.dc99efe1.jpg";